import { useEffect, useMemo } from 'react';
import { differenceInHours } from 'date-fns';
import { useAtomValue } from 'jotai';
import appConfig from 'app-config';
import WebToAppModal from 'src/components/WebToAppModal';
import useLogin from 'src/hooks/useLogin';
import { eventMatchPageAtom } from 'src/stores/match/atoms';
import { webToAppLastModalShownAtom } from 'src/stores/webToApp/atom';
import { ModalType } from 'src/types/Modal';
import { WebToAppModalType } from 'src/types/WebToApp';
import getDeviceInfo from 'src/utils/device/info';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useWebToAppModal: OrderedModalHookType = modalPropsPromise => {
  const lastModalShown = useAtomValue(webToAppLastModalShownAtom);
  const eventMatchPage = useAtomValue(eventMatchPageAtom);
  const {
    isLogin
  } = useLogin();
  const shouldShowModal = useMemo(() => {
    const {
      isMobile,
      isWebKit
    } = getDeviceInfo();

    /** TODO: Vividi iOS 리뷰 통과 이후에 오픈 */
    if (appConfig.serviceCode === 'vividi') return false;
    if (!isMobile || !isLogin) return false;

    // WEB-4805: iOS 모바일에서는 web_to_app 모달을 노출하지 않음 (iOS 리뷰 정책 대응, 추후 원복 가능)
    if (isWebKit) return false;
    if (eventMatchPage !== 'main') return false;
    if (lastModalShown === null) return true;
    const now = new Date();
    const lastShownDate = lastModalShown;
    const hoursDiff = differenceInHours(now, lastShownDate);
    return hoursDiff >= 24;
  }, [eventMatchPage, lastModalShown, isLogin]);
  useEffect(() => {
    modalPropsPromise?.resolve(shouldShowModal ? [{
      modalProps: {
        key: ModalType.WEB_TO_APP,
        component: () => <WebToAppModal type={WebToAppModalType.BASIC} />
      }
    }] : null);
  }, [shouldShowModal, modalPropsPromise]);
};
export default withLoginUserModalPromise(useWebToAppModal);